import { api, ApiRoutes } from './ApiService';
import { Hersteller } from '../types/Hersteller';
import { branchCategoryIdsKey } from '../helpers/branchCategoryHelper';

export const fetchHerstellers = async (params: {
    branchCategoryIds?: number[];
    categoryId?: number | null;
} = {}): Promise<Hersteller[]> => {
    const queryParams: Record<string, string> = {};

    if (params.branchCategoryIds?.length) {
        queryParams.branchCategoryIds = branchCategoryIdsKey(params.branchCategoryIds);
    }
    if (params.categoryId != null && params.categoryId > 0) {
        queryParams.categoryId = String(params.categoryId);
    }

    const response = await api.get(
        ApiRoutes.HERSTELLER,
        undefined,
        Object.keys(queryParams).length ? queryParams : undefined
    );

    return response.data?.data?.herstellers ?? [];
};
